import { isArray } from '@src/utils/index'

export const getDefaultFactorValue = (obj) => {
  if (obj) {
    if (obj.show && obj.show.defaultValue) {
      return obj.show.defaultValue
    } else {
      if (obj.values && obj.values[0]) {
        return obj.values[0].customizeValue
      } else {
        return ''
      }
    }
  } else {
    return ''
  }
}


export const sortData = (key, arr = []) => {
  if (arr[0] && arr[0][key]) {
    arr.sort((item1, item2) => {
      return item1[key] > item2[key] ? 1 : -1
    })
  }
  return arr
}

export const sortInformQuestionList = (arr = [], questionCodes) => {
  console.log(questionCodes, arr)
  if (questionCodes && isArray(arr)) {
    const questionArray = questionCodes.split(',') || []
    arr.sort((item1, item2) => {
      if (item1.questionCode === item2.questionCode) {
        return item1.informGroupType === 'HOLDERINFORM' ? -1 : 1
      }
      return questionArray.indexOf(item1.questionCode) > questionArray.indexOf(item2.questionCode) ? 1 : -1
    })
  }
  return arr
}

// 将同一类名的元素设置为最大的高度 统一高度
export const equalElementMaxHeight = (className) => {
  if (typeof window !== 'undefined') {
    const doms = document.getElementsByClassName(className)
    if (doms) {
      let maxHeight = 0
      for (const key in doms) {
        const height = doms[key].offsetHeight
        if (maxHeight < height) {
          maxHeight = height
        }
      }
      for (const key in doms) {
        if (doms[key] && doms[key].style) {
          doms[key].style.height = maxHeight + 'px'
        }
      }
    }
  }
}
// 将同一类名的元素设置为最大的宽度 统一宽度
export const equalElementMaxWidth = (className) => {
  if (typeof window !== 'undefined') {
    const doms = document.getElementsByClassName(className)
    if (doms) {
      const doms1 = Array.from(doms)
      const maxWidth = Math.max(...doms1.map(dom => dom.offsetWidth))
      for (const key in doms) {
        if (doms[key] && doms[key].style) {
          doms[key].style.width = maxWidth + 'px'
        }
      }
    }
  }
}
